type Nullable<T> = T | null | undefined;

type PropNonNullable<T, TKey extends keyof T> = T & { [P in TKey]-?: NonNullable<T[P]> };

type PropNullable<T, TKey extends keyof T> = T & { [P in TKey]-?: Nullable<T[P]> };

export const valueNotNull =
  <T, TKey extends keyof T>(key: TKey) =>
  (vals: T): vals is PropNonNullable<T, TKey> =>
    vals != null && vals[key] != null;

export const valueNull =
  <T, TKey extends keyof T>(key: TKey) =>
  (vals: T): vals is PropNullable<T, TKey> =>
    vals != null && vals[key] == null;
